import { useMemo } from 'react';
import { useThesaurusTree } from '@/hooks/api/useThesaurus';
import { buildTree } from '@/utils/dedaloUtils';
import { TreeDataContext } from './treeDataContext';

export default function TreeDataProvider({ children }) {
    const { data, isLoading, error } = useThesaurusTree();
    const treeData = useMemo(
        () => (data ? buildTree(data) : { menu: [], extra: {}, pathOrder: [] }),
        [data]
    );

    return (
        <TreeDataContext.Provider value={{ treeData, isLoading, error }}>
            {children}
        </TreeDataContext.Provider>
    );
}